module.exports = __webpack_public_path__ + "static/favicon-8848fb9e18e01a1143d094d69bea69cd.ico";